<template>
    <el-dialog
        class="platform"
        :visible.sync="platformVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="Add Platform"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="platForm"
                :model="platForm"
                :rules="rules"
            >
                <el-row>
                    <el-col :span="24">
                        <div  style="padding:0 0 10px 0"> 
                            <div><span @click="addItem(1)" class="add">Add Platform</span></div>
                        </div>
                        <el-table
                            :data="platForm.tableData"
                            ref="tableData"
                            highlight-current-row
                            max-height="300"
                            @selection-change="handleSelectionChange"
                        >
                            <el-table-column
                                label="Platform"
                                property="platform"
                                align="left"
                                min-width="150"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        label-width="0"
                                        v-if="scope.row.show == 1"
                                         prop="platform"
                                        :rules="[{validator: (_, __, callback) => !!scope.row.platform || callback(), trigger: ['blur', 'change']}]"
                                    >
                                        <el-select
                                            v-model="scope.row.platform"
                                            clearable
                                            filterable
                                            size="small"
                                            :id="`platform-${scope.row.idx}`"
                                            
                                        >
                                            <el-option
                                                :label="item.name"
                                                :value="item.id.toString()"
                                                v-for="item of platformList"
                                                :key="item.name"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Logistics Name"
                                align="center"
                                prop="carrier_code"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        label-width="0"
                                        required
                                        prop="logistics"
                                        :rules="[{validator: (_, __, callback) => !!scope.row.logistics || callback(), trigger: ['blur', 'change']}]"
                                    >
                                    <el-input
                                        clearable
                                        maxlength="100"
                                        v-model="scope.row.logistics"
                                        size="small"
                                        :id="`logistics-${scope.row.idx}`"
                                    ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Company"
                                align="center"
                                prop="carrier_name"
                            >
                                <template slot-scope="scope">
                                    <el-form-item
                                        label-width="0"
                                        prop="company"
                                        :rules="[{validator: (_, __, callback) => !!scope.row.company || callback(), trigger: ['blur', 'change']}]"
                                    >
                                    <el-input
                                        clearable
                                        maxlength="100"
                                        v-model="scope.row.company"
                                        size="small"
                                        :id="`company-${scope.row.idx}`"
                                    ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="left"
                                    label="Operation"
                                    width="130"
                                    class-name="pt-7"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-plus"
                                            @click="addItem(0, scope.row)"
                                        ></el-button>
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            v-show="platForm.tableData.length > 1"
                                            @click="removeItem(scope)"
                                        ></el-button>
                                    </template>
                                </el-table-column>

                        </el-table>
                    </el-col>
                    
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="closeDialog"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";

export default {
    data() {
        return {
            platForm: {
                lastmile_id: "",
                tableData: [],
            },
            
            emptyTableItem:{},
            idx: 0,
            validated: false
        };
    },
    methods: {
        addItem(s, row) {
            const id = `rowid-${++this.idx}`

            this.emptyTableItem = {
                idx: id,
                platform: row && row.platform || '',
                show: s,
                logistics: '',
                company: '',
            };

            let index = -1
            for (let i = this.platForm.tableData.length - 1; i >= 0; i--) {
                if (this.platForm.tableData[i].platform === this.emptyTableItem.platform) {
                    index = i
                    break
                }
            }

            if (index > -1) this.platForm.tableData.splice(index + 1, 0, this.emptyTableItem)
            else this.platForm.tableData.push(this.emptyTableItem)

            this.$nextTick(() => {
                const elmId = (s && 'platform' || 'logistics') + `-${id}`
                const elm = document.querySelector(`#${elmId}`)
                elm.scrollIntoView({behavior: 'smooth'})
                elm.focus()
                this.$refs["platForm"].clearValidate();
            })
        },
        removeItem(scope) {
            const platformId = scope.row.platform;
            if (this.platForm.tableData.length > 1) {
                for (let i in this.platForm.tableData) {
                    if (i == scope.$index) {
                        this.platForm.tableData.splice(i, 1);
                        const next = this.platForm.tableData.find(item => item.platform === platformId);
                        next && (next.show = true)
                        return
                    }
                }
            }
        },
        closeDialog() {
            this.$refs["platForm"].clearValidate();
            this.$nextTick(() => {
                this.platformVisible = false
                this.$emit("update:platformVisible", false);
            });
        },
        lastMile(){
            cmofferApi
                .lastMile({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.platForm.lastmile_id = res.data.id
                        this.platForm.tableData = res.data.express2
                    }
                })
                .catch(() => {});
        },
        save(){
            this.loading = true;
                cmofferApi.lastMileExpressUpdate(
                    {
                        ...this.platForm,
                    },
                    "post"
                )
                .then((res) => {
                    this.loading = false;
                    this.closeDialog();
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.$parent[this.funcName] &&
                            this.$parent[this.funcName]();
                        this.closeDialog();
                });
        },
    },
    activated() {
        //this.platformSelect();
    },
    props: {
        platformVisible: Boolean,
        tableItem: Object,
        funcName: String,
        platformList: Array,
    },
    watch: {
        platformVisible(val) {
            if (val) {
                
                this.lastMile();
                
                // cmofferApi
                //     .expressSelect({}, "get")
                //     .then((res) => {
                //         if (res) {
                //             this.expressList = res.data;
                //         }
                //     });
            }
        },
    },
};
</script>
<style lang="scss" scoped>

.platform {
    ::v-deep .container {
        .el-table {
            td {
                vertical-align: top;

                &.pt-7 {
                    .cell {
                        padding-top: 7px;
                    }
                }
            }
        }
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--medium {
            margin-bottom: 0!important;

            &.is-error {
                margin-bottom: 22px !important;
            }
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
        .add{
            color: rgb(60, 60, 253);
            cursor: pointer;
        }
    }
}
</style>
